import { OnChangeParams } from 'baseui/select';
import { useMemo } from 'react';
import { GPS_TYPE_OPTIONS } from '../../../constants/gps';
import { GpsType } from '../../../types/device';
import EnhancedLabeledSelect from '../../ui/EnhancedLabeledSelect';

type Props = {
  selectedId?: GpsType;
  onChangeId?: (id?: GpsType) => void;
  isFilter?: boolean;
  label?: string;
  emptyOptionText?: string;
  showEmptyOption?: boolean;
  error?: React.ReactNode;
  onBlur?: () => void;
  inline?: boolean;
  clearable?: boolean;
  required?: boolean;
  disabled?: boolean;
  selectMaxWidth?: number;
};

function GpsTypeSelect({
  selectedId,
  onChangeId,
  isFilter = true,
  label = 'Tipo de GPS:',
  emptyOptionText = 'Seleciona un tipo',
  showEmptyOption = false,
  error,
  onBlur,
  inline,
  clearable = false,
  required = false,
  disabled = false,
  selectMaxWidth,
}: Readonly<Props>) {
  const gpsTypeOptions = useMemo(() => {
    const coreOptions = GPS_TYPE_OPTIONS.map((gpsType) => ({
      id: gpsType.id,
      label: gpsType.label,
    }));
    const options = showEmptyOption
      ? [
          {
            id: undefined,
            label: isFilter ? 'Todos' : emptyOptionText,
          },
          ...coreOptions,
        ]
      : coreOptions;
    return options;
  }, []);

  const onSelectedChange = (params: OnChangeParams) => {
    if (params.option?.id) {
      onChangeId && onChangeId(params.option.id as GpsType);
    } else {
      onChangeId && onChangeId(undefined);
    }
  };

  return (
    <EnhancedLabeledSelect
      label={label}
      options={gpsTypeOptions}
      value={showEmptyOption || selectedId !== undefined ? [{ id: selectedId }] : undefined}
      onChange={onSelectedChange}
      fullWidth
      onBlur={() => {
        onBlur && onBlur();
      }}
      searchable
      inline={inline}
      inset={inline}
      error={error}
      required={required}
      clearable={clearable}
      placeholder={emptyOptionText}
      disabled={disabled}
      selectMaxWidth={selectMaxWidth}
    />
  );
}

export default GpsTypeSelect;
